import { useId, useState } from 'react';
import { Link } from 'react-router-dom';
import { Info, X, ExternalLink } from 'lucide-react';
import { guideById, guideHref } from '@/lib/userGuide.mjs';
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';
import GuideTopicBody from '@/components/GuideTopicBody';

export default function HelpLink({ topic, label, compact = true, className = '' }) {
  const [open, setOpen] = useState(false);
  const titleId = useId();
  const href = guideHref(topic);
  const section = guideById.get(topic);
  if (!href || !section) return null;
  const title = label || section.title;
  return <Popover open={open} onOpenChange={setOpen} modal={false}>
    <PopoverTrigger asChild>
      <button type="button" className={`context-help ${compact ? '' : 'context-help--label'} ${className}`}
        title={`Afficher l’aide : ${title}`} aria-label={`Afficher l’aide : ${title}`} data-help-topic={topic}
        onClick={(e) => e.stopPropagation()}>
        <Info size={15} aria-hidden="true" />{!compact && <span>Aide</span>}
      </button>
    </PopoverTrigger>
    <PopoverContent className="help-popover" align="start" side="bottom" sideOffset={8} collisionPadding={12}
      aria-labelledby={titleId} onClick={(e) => e.stopPropagation()}>
      <header className="help-popover-heading"><h2 id={titleId}>{section.title}</h2>
        <button type="button" className="help-popover-close" onClick={() => setOpen(false)} aria-label="Fermer l’aide"><X size={14} aria-hidden="true" /><span>Fermer</span></button>
      </header>
      <div className="help-popover-body" tabIndex={0} aria-label={`Contenu de l’aide : ${section.title}`}><GuideTopicBody topic={section} compact /></div>
      <footer className="help-popover-footer"><Link to={href} target="_blank" rel="noopener noreferrer"
        aria-label={`Ouvrir la documentation : ${section.title} (nouvel onglet)`} onClick={() => setOpen(false)}>
        Ouvrir cette section dans la documentation <ExternalLink size={13} aria-hidden="true" />
      </Link></footer>
    </PopoverContent>
  </Popover>;
}
